





import Vue from 'vue'
import { fetchAndSaveBrandData } from './helper'
import postscribe from 'postscribe'

export default Vue.extend({
  metaInfo() {
    return {
      title: this.$store.getters.pageTitle,
      link: [
        {
          vmid: 'favicon',
          rel: 'shortcut icon',
          href: this.$store.getters.favicon
        }
      ],
      style: [
        {
          cssText: this.siteCustomCss,
          type: 'text/css',
          vmid: 'site-custom-css'
        }
      ],
      script: [
        {
          innerHTML: this.siteCustomJs,
          type: 'text/javascript',
          vmid: 'site-custom-js',
          body: true,
          async: true
        }
      ]
    }
  },
  async mounted() {
    try {
      const brandData = await fetchAndSaveBrandData(this)

      if (brandData) {
        const { customJs, customCss, customHeader, customFooter } = brandData
        this.siteCustomJs = customJs || ''
        this.siteCustomCss = customCss || ''
        if(customHeader) {
          postscribe(`#siteCustomHeader`, customHeader)
        }
        if(customFooter) {
          postscribe(`#siteCustomFooter`, customFooter)
        }
      }
    } catch (error) {
      console.error('Error while fetching brand data --> ', error)
    }
  },
  data() {
    return {
      siteCustomJs: '',
      siteCustomCss: ''
    }
  }
})
